import { Skeleton, Typography } from '@mui/material'
import { makeStyles } from '@mui/styles'
import React from 'react'

const useStyles = makeStyles((theme) => ({
  title: {
    fontWeight: 500,
  },
  error: {
    color: theme.palette.error.main,
    fontSize: 13,
  },
}))

const CheckList = ({
  title,
  children,
  error = '',
  isLoading = false,
}: {
  title: string
  children: React.ReactNode
  error?: string
  isLoading?: boolean
}) => {
  const classes = useStyles()

  if (isLoading) {
    return (
      <>
        {[...Array(5).keys()].map((el) => (
          <Skeleton key={el} variant="rectangular" sx={{ marginBottom: 1 }} />
        ))}
      </>
    )
  }

  return (
    <>
      <Typography className={classes.title}>{title}</Typography>
      {children}
      {error ? (
        <Typography className={classes.error}>{error}</Typography>
      ) : null}
    </>
  )
}

export default CheckList
